// extracted by mini-css-extract-plugin
module.exports = {"singleValue":"OurValuesCard_singleValue__k73ds","titleContainer":"OurValuesCard_titleContainer__cnqCD","title":"OurValuesCard_title__RlKuW","text":"OurValuesCard_text__LdBaK"};